import('./summary.scss')

export default function Summary(opts={}){
    BaseConstructor.call(this)
    let {container,timer} = opts
    let elements = {}
    let context = this


    this.generate = () =>{
        elements.container = context.createElement('div', 'summary-container')
        
        generateTitle()

        generateStatuses()

        $(document).find('#canvas').append(elements.container)
    }

    this.setPosition = () =>{

    }

    const generateStatuses = () =>{
        elements.statuses_container = context.createElement('div', 'statuses-container', '')
        elements.statuses_list_container = context.createElement('div', 'statuses-list-container', '<div class="title">Lista de Status</div>')
        
        let colors = ['white', 'yellow', 'orange', 'red']
        colors.forEach(color=>{
            $(elements.statuses_list_container).append(`<div class='list-item'><div class='square' style='background-color:${color}'></div><div>${colorToStatus(color)}</div></div>`)
        })

        $(elements.statuses_container).append(elements.statuses_list_container)
        $(elements.container).append(elements.statuses_container)
    }

    const colorToStatus = color =>{
        let data = {
            white: 'Normal',
            yellow: 'Atenção',
            orange: 'Alerta',
            red: 'Extravasamento',
        }
        return data[color]
    }

    const generateTitle = () =>{
        elements.title_container = context.createElement('div', 'title-container', '')
        elements.title = context.createElement('div', 'title', 'Sistema Tietê/Pinheiros')

        $(elements.title_container).append(elements.title)
        $(elements.container).append(elements.title_container)
    }
}

Summary.prototype = Object.create(BaseConstructor.prototype)